import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-redirection-message',
  templateUrl: './redirection-message.component.html',
  styleUrls: ['./redirection-message.component.scss']
})
export class RedirectionMessageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
